// Custom object for TimePicker
// reason: antd v5 with MomentJS incompatibility

import React from 'react';
import { TimePicker, TimeRangePickerProps } from 'antd';
import type { Moment } from 'moment';
import moment from 'moment';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

interface IComponentProps {
  value: [Moment, Moment] | null;
  onChange: (value: [Moment, Moment] | null) => void;
}

const CustomTimeRangePicker: React.FC<IComponentProps & TimeRangePickerProps> = ({ value, onChange, ...rest }) => {
  return (
    <TimePicker.RangePicker
      value={value ? ([dayjs(value[0].toDate()), dayjs(value[1].toDate())] as [Dayjs, Dayjs]) : null}
      onChange={(val) => {
        if (!val || val.length !== 2 || !val[0] || !val[1]) {
          onChange(null);
        } else {
          onChange([moment(val[0].toDate()), moment(val[1].toDate())]);
        }
      }}
      format="HH:mm"
      {...rest}
    />
  );
};

export default CustomTimeRangePicker;
